// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__3_ugw","logo":"Navbar_logo__1bsQS","sessionbutton":"Navbar_sessionbutton__1yJL5","profile":"Navbar_profile__2snP8","session":"Navbar_session__fU6Pw"};